import { MonitoringService } from '@anecdotes/monitoring';
import { ServerEventsProviderService } from '@anecdotes/server-events';
import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { tap } from 'rxjs';

// const errorConnectionStates = new Set([ConnectionState.Failed, ConnectionState.Unavailable, ConnectionState.Disconnected]);

@Injectable()
export class LogEffects {
  constructor(private logger: MonitoringService, private serverEventsProvider: ServerEventsProviderService) {}

  logPusherEvent$ = createEffect(
    () =>
      this.serverEventsProvider
        .getServerEventsFeed()
        .pipe(tap((serverEvent) => this.logger.sendEvent('PUSHER_EVENT', serverEvent))),
    { dispatch: false }
  );


  /** It's commented as for now we don't need these logs in DD */

  // logPusherConnectionState$ = createEffect(
  //   () =>
  //     this.serverEventsProvider
  //       .getConnectionState()
  //       .pipe(tap((connectionState) => {
  //         const eventInfo = {
  //           name: `pusher_connection_is_${connectionState}`.toUpperCase(),
  //           data: { connectionState }
  //         };

  //         if (errorConnectionStates.has(connectionState)) {
  //           this.logger.addError(new Error(eventInfo.name), eventInfo.data);
  //         } else {
  //           this.logger.sendEvent(eventInfo.name, eventInfo.data);
  //         }
  //       })),
  //   { dispatch: false }
  // );

  // logPusherLogs$ = createEffect(
  //   () =>
  //     this.serverEventsProvider
  //       .getLogs()
  //       .pipe(tap((pusherLog) => {
  //         this.logger.sendEvent(pusherLog.toUpperCase());
  //       })),
  //   { dispatch: false }
  // );
}
